import React from "react";

/** Syrian Revolution/Independence flag — green/white/black with 3 red stars. */
export default function SyrianFlag({ className = "inline-block align-middle", width = 20, height = 14, title = "علم الجمهورية العربية السورية" }) {
  return (
    <svg
      viewBox="0 0 30 20"
      width={width}
      height={height}
      className={className}
      role="img"
      aria-label={title}
      style={{ borderRadius: 2, border: "1px solid rgba(0,0,0,0.1)" }}
    >
      <title>{title}</title>
      {/* Green stripe */}
      <rect width="30" height="20" fill="#007A3D" />
      {/* White stripe */}
      <rect y="6.67" width="30" height="6.67" fill="#FFFFFF" />
      {/* Black stripe */}
      <rect y="13.33" width="30" height="6.67" fill="#000000" />
      {/* Three red stars on the white stripe */}
      {[7.5, 15, 22.5].map((cx, i) => (
        <Star key={i} cx={cx} cy={10} r={1.6} />
      ))}
    </svg>
  );
}

/** 5-pointed star, one point up, red. */
function Star({ cx, cy, r }) {
  const points = [];
  for (let i = 0; i < 10; i++) {
    const angle = (Math.PI / 5) * i - Math.PI / 2;
    const rad = i % 2 === 0 ? r : r / 2.5;
    points.push(`${cx + rad * Math.cos(angle)},${cy + rad * Math.sin(angle)}`);
  }
  return <polygon points={points.join(" ")} fill="#CE1126" />;
}
